var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#D2463D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3868 29.2513L40.5685 22.7056C39.5942 21.0364 37.7898 20 35.8566 20H28.1414C26.2093 20 24.4037 21.0364 23.4295 22.7056L19.6122 29.2513C18.6227 30.9467 18.6227 33.0533 19.6122 34.7487L23.4306 41.2944C24.4048 42.9636 26.2093 44 28.1424 44H35.8577C37.7898 44 39.5953 42.9636 40.5696 41.2944L44.3879 34.7487C45.3774 33.0533 45.3763 30.9467 44.3868 29.2513ZM30.9244 26.5458C30.9244 25.9425 31.4131 25.4548 32.0154 25.4548C32.6176 25.4548 33.1063 25.9425 33.1063 26.5458V32.546C33.1063 33.1493 32.6176 33.637 32.0154 33.637C31.4131 33.637 30.9244 33.1493 30.9244 32.546V26.5458ZM32.0154 38.5463C31.112 38.5463 30.3789 37.8132 30.3789 36.9099C30.3789 36.0065 31.112 35.2734 32.0154 35.2734C32.9187 35.2734 33.6518 36.0065 33.6518 36.9099C33.6518 37.8132 32.9187 38.5463 32.0154 38.5463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.32d241d19fb1f281cd9c3678ad95d6ca.svg";
export { ForwardRef as ReactComponent };